import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController, ModalController, NavController, NavParams } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { DetalleFormatoService } from './detalleFormato.services';

@Component({
  selector: 'app-detalle-formato',
  templateUrl: './detalle-formato.page.html',
  styleUrls: ['./detalle-formato.page.scss'],
  providers:[TranslateService, GeneralServices, DetalleFormatoService]
})
export class DetalleFormatoPage implements OnInit {
  public loader;
  public errorMessage;

  public IdSisDeta;
  public NombrePaciente;
  public ViaIngreso;
  public NomUnidadFuncional;
  public Estudio;
  public NomEmpresa;
  public FechaIngreso;
  public Descripcion;
  public tipoFiltro;

  public examenObject;

  public cuerpoArray=[];

  public hasSave = false;
  public formatosDiagnosticosClass;
  private dataUser;
  public readonly;

  public arrayClasificacionIMC;
  public _parentClass;

 constructor(private platform: Platform, 
    private translate: TranslateService, 
    private _generalServices:GeneralServices,
    private loadingCtrl: LoadingController,
    private route: ActivatedRoute,
    private router:Router,
    private _detalleFormatoService:DetalleFormatoService,
    public modalController: ModalController,
    public navCtrl: NavController, public navParams: NavParams,) {
      
      this.examenObject = JSON.parse(navParams.get('ExamenObject'));
      this.readonly = navParams.get('readonly');
      this.tipoFiltro = JSON.parse(navParams.get('tipoFiltro'));
      this.formatosDiagnosticosClass = navParams.get('formatosDiagnosticosClass');
      this._parentClass = navParams.get('_parentClass');
      this.dataUser=JSON.parse(sessionStorage.getItem('dataUser'))[0];

      
    this._generalServices.setLanguage(this.translate);
   }


   closeModal(){
      this._parentClass.modalController.dismiss();
   }
  ngOnInit() {
    this.cargarFormato();
  }

  cargarFormato(){
    //this.CodigoFormatoSelected=0;
    let _thisClass=this;
/*
    this.loader = this.loadingCtrl.create({
                    content: _thisClass.translate.instant('TXT_CARGANDO_EXAMENES'),
                  });
    this.loader.present();*/

    if(this.readonly){
      this.examenObject.formatoSelected = this.examenObject.CodFormatoUsado;
    }

    this._detalleFormatoService.getFormatoResultado(this.examenObject.id, this.examenObject.formatoSelected, this.examenObject.Estudio, this.examenObject.HasFormato).subscribe(
    result => {
      
      this.cuerpoArray=[];

      if(result!='' && result!= null){
          this.arrayClasificacionIMC = result["ClasificacionIMC"];

          result["Cuerpo"].forEach( ( x ) => {
              //x.DataJsonSelect = JSON.parse(x.DataJsonSelect);
              x.valorA = x.defecto;
              x.valorB = '';  

              if(x.tipo == 3 || x.tipo == 7 || x.tipo == 18){
                x.valorA = false;  
                if(x.defecto == 'SI'){
                  x.valorA = true;
                }
              }

              if(x.tipo == 4){
                x.valorA = x.defecto.replace(/\//g, '-');
              }

              if(x.tipo == 7){
                let valores = x.defecto.split('|');
                x.valorA = false;
                if(valores[0] == 'SI'){
                  x.valorA = true;
                }
                x.valorB = valores[1];
              }

              if(x.tipo == 18){
                x.valorA = false;
                if($.trim(x.defecto) != ''){
                  x.valorA = true;
                }
              }
              

              if(x.DataJsonCombo == '' || x.DataJsonCombo == null){
                x.DataJsonCombo = [];
              }else{                  
                x.DataJsonCombo = JSON.parse(x.DataJsonCombo);  
              }

              

              if(x.tipo == 12){
                let imc = x.defecto.split('-');       
                x.valorA = imc[0];
                x.valorB = imc[1];
                this.calcularIMC(x);
              }

              

              this.cuerpoArray.push( x );
              
          });

          console.log(this.cuerpoArray);
      }

      ////this.loader.dismiss();
    },
    error =>{
      this.errorMessage = <any>error;
      if(this.errorMessage !== null){
        console.log(this.errorMessage);
      }
    }
    );
}

guardarFormato(){
  //console.log(this.examenObject);
  //console.log(this.cuerpoArray);
  this.setDataDefault();
  if(this.examenObject.HasFormato == 1){
    this.guardarFormatoDinamico();
  }else{
    this.guardarFormatoEstatico();
  }
}

setDataDefault(){
  //console.log(this.dataUser.Cedula);    
  for(let i in this.cuerpoArray){
    if(this.cuerpoArray[i].tipo == '17'){
      this.cuerpoArray[i].valorA = this.dataUser.Cedula;
    }
  }
}

guardarFormatoDinamico(){
  let currentDate = new Date();
  let day = currentDate.getDate()
  let month = currentDate.getMonth() + 1
  let year = currentDate.getFullYear()
  
  let fecha=year+'';
  
  if(month < 10){
    fecha+= '-0'+month;
  }else{
    fecha+= '-'+month;
  }

  if(day < 10){
    fecha+= '-0'+day;
  }else{
    fecha+= '-'+day;
  }
  
  
  let valores=[];
  for(let i in this.cuerpoArray){
    valores.push({"posicion": this.cuerpoArray[i].posicion,        
                  "posicion_fija": this.cuerpoArray[i].posicion_fija,
                  "campo": this.cuerpoArray[i].campo,
                  "grupo": this.cuerpoArray[i].grupo,
                  "tipo": this.cuerpoArray[i].tipo,
                  "obligatorio": this.cuerpoArray[i].obligatorio,
                  "defecto": this.cuerpoArray[i].defecto,
                  "ExpRegular": this.cuerpoArray[i].ExpRegular,
                  "nomgrupo": this.cuerpoArray[i].nomgrupo,
                  "DataJsonCombo": this.cuerpoArray[i].DataJsonCombo,
                  "valorA": this.cuerpoArray[i].valorA,
                  "valorB": this.cuerpoArray[i].valorB,
                  "resultadoIMC": $.trim(this.cuerpoArray[i].resultadoIMC),
                }
                )
  }

  let data = {
    "IdSisDeta": this.examenObject["id"],
    "FechaResultado": fecha,
    "CodPlantilla": this.examenObject["formatoSelected"],
    "Estudio": this.examenObject["Estudio"],
    "CedulaUsuario": this.dataUser.Cedula,
    "HoraResultado": this._generalServices.getFormatedTime(currentDate),
    "MedEspecialista": this.dataUser.CodMedico,
    "User": this.dataUser.Nombre,
    "Data": valores
  };
  this._detalleFormatoService.SavePlantillaDinamica(data).subscribe(
    result => {
      this.readonly = true;
      this.hasSave = true;
      this.formatosDiagnosticosClass.setTipoFiltro(0);
      ////this.loader.dismiss();
      this._generalServices.toastNotify("Se han guardado los datos correctamente.","success");
    },
    error =>{
      
      ////this.loader.dismiss();
      this._generalServices.toastNotify(error._body,"error");
      this.errorMessage = <any>error;
      if(this.errorMessage !== null){
        console.log(this.errorMessage);
      }
    }
    );

  console.log(data);


}
guardarFormatoEstatico(){
  let valores=[];
  for(let i in this.cuerpoArray){
    valores.push({"valor": "valor"+this.cuerpoArray[i].posicion, "resultado": this.cuerpoArray[i].valorA})
  }

  let data = {
    "idSisDeta": this.examenObject["id"],
    "fechaResultado": "2020-01-09",
    "fechaMinima": "2020-01-09",
    "codPlantilla": this.examenObject["formatoSelected"],
    "estudio": this.examenObject["Estudio"],
    "cups": this.examenObject["Cups"],
    "calificacion": 0,
    "cedulaUsuario": "34431840",
    "horaResultado": "11:00",
    "medEspecialista": 399,
    "user": "mario vascod",
    "valores": valores
  };
  this._detalleFormatoService.SavePlantillaEstatica(data).subscribe(
    result => {

      this.hasSave = true;
      this.formatosDiagnosticosClass.setTipoFiltro(0);
      //this.loader.dismiss();
      this._generalServices.toastNotify("Se han guardado los datos correctamente.","success");
    },
    error =>{
      //this.loader.dismiss();
      this._generalServices.errorManager(error,this.loader,true);
      this.errorMessage = <any>error;
      if(this.errorMessage !== null){
        console.log(this.errorMessage);
      }
    }
    );

  console.log(data);
}

calcularIMC(cuerpo){
  let imc = cuerpo.valorA / (cuerpo.valorB * cuerpo.valorB);
  imc = parseFloat(imc.toFixed(2));
  cuerpo["resultadoIMC"] = imc;

  for(let i in this.arrayClasificacionIMC){
    if(imc >= this.arrayClasificacionIMC[i].Min && imc <= this.arrayClasificacionIMC[i].Max){
      cuerpo["clasificacionIMC"] = this.arrayClasificacionIMC[i].Descripcion;
    }
  }

  if($.trim(cuerpo.valorA) == '' || $.trim(cuerpo.valorB) == ''){
    cuerpo["resultadoIMC"] = '';
    cuerpo["clasificacionIMC"] = '';
  }
}

ionViewDidLoad() {
  console.log('ionViewDidLoad DetalleFormatoPage');
}

}
